/*! font */
$(document).ready(function () {

    // Replace font tags
    // Because they are gross
    // Also they copy over from Word
    $("font").replaceWith(  //find all font tags and call replace with to change the element
        function () {
            var tag = $(this);
            return $("<span/>")  //create new span
                .html(tag.html());  //set html of the new span with what was in font tag
        }
    );
});